import { createRoot } from "react-dom/client";
import "./index.css";
import HeroSplitSection from "./App.jsx";

function initHeroSplitSection() {
  const container = document.getElementById("hero-split-root");
  if (container) {
    const root = createRoot(container);
    root.render(<HeroSplitSection />);
  } else {
    console.warn("Hero split section container #hero-split-root not found");
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHeroSplitSection);
} else {
  initHeroSplitSection();
}
